import {isElementInViewport} from "../../../util/viewport";

function setUpCounter(counter, frequency, limit, step) {
  if(typeof step === "undefined") {
    step = 1;
  }
  let i = 0;

  const inv = setInterval(function() {
    if(i < limit) {
      i = Math.min(i+step, limit);
      counter.innerHTML = i;
    } else {
      clearInterval(inv);
    }
  }, frequency);
}

function counterActivationFunction(scope) {
  Array.from(scope.querySelectorAll(".js-counter:not(.activated)")).forEach(counter => {
    if(isElementInViewport(counter)) {
      counter.classList.add("activated");
      const value = parseInt(counter.innerText);
      const step = parseInt(counter.dataset.step || 1);
      const frequency = parseInt(counter.dataset.frequency || (parseFloat(counter.dataset.duration) * 1000 / (value / step)));
      setUpCounter(counter, frequency, value, step);
    }
  });
}

function setUpCounters(scope) {
  window.addEventListener('scroll', () => counterActivationFunction(scope));
  counterActivationFunction(document);
}

export {setUpCounters};
